import type { z } from 'zod';

/**
 * Validate an API response against a Zod schema.
 * Non-breaking: logs a warning in development if the response doesn't match,
 * but always returns the original data so the app keeps working.
 */
export function validateResponse<T>(
  schema: z.ZodType<T>,
  data: unknown,
  label: string,
): T {
  const result = schema.safeParse(data);
  if (!result.success) {
    console.warn(
      `[API contract drift] ${label}:`,
      result.error.issues.map(i => `${i.path.join('.')}: ${i.message}`),
    );
    // Validation failed but we return original data to keep the app working.
    // The cast is intentional: this function is advisory-only so the frontend
    // degrades gracefully when the backend drifts ahead of the schema.
    return data as T;
  }
  return result.data;
}
